import {
  ADD_CLIPBOARD_PRODUCT_CODES,
  AddClipBoardProductCodesAction,
  CLEAR_CLIPBOARD,
  ProductIdCodes,
  RESET_CLIPBOARD,
  SET_CLIPBOARD_PRODUCT_CODES,
  SetClipBoardProductCodesAction,
  VERIFY_CLIPBOARD_PRODUCT_CODES,
} from "./ClipBoardTypes";

export interface ClipBoardState {
  productCodes: string[];
  invalidProductCodes: string[];
  isValidatingProductCodes: boolean;
  currentAction: string | null;
  validProductIds: string[];
  productIdCodes: ProductIdCodes[];
}

const initialState: ClipBoardState = {
  productCodes: [],
  invalidProductCodes: [],
  isValidatingProductCodes: false,
  currentAction: null,
  validProductIds: [],
  productIdCodes: [],
};

export const ClipBoardReducer = (
  state: ClipBoardState = initialState,
  action,
) => {
  switch (action.type) {
    case SET_CLIPBOARD_PRODUCT_CODES: {
      const productCodes = action as SetClipBoardProductCodesAction;
      const items = productCodes.payload.productCodes;
      const filterCodes = new Set(items);
      const uniqueCodes = Array.from(filterCodes);
      return {
        ...state,
        productCodes: uniqueCodes,
        currentAction: null,
      };
    }
    case ADD_CLIPBOARD_PRODUCT_CODES: {
      const codes = action as AddClipBoardProductCodesAction;
      const updatedCodes = codes.payload.productCodes;
      return {
        ...state,
        productCodes: updatedCodes,
        currentAction: null,
      };
    }
    case CLEAR_CLIPBOARD:
      return {
        ...state,
        productCodes: [],
        invalidProductCodes: [],
        currentAction: null,
      };

    case VERIFY_CLIPBOARD_PRODUCT_CODES.REQUEST: {
      return {
        ...state,
        isValidatingProductCodes: true,
        currentAction: null,
        validProductIds: [],
        productIdCodes: [],
      };
    }
    case VERIFY_CLIPBOARD_PRODUCT_CODES.SUCCESS: {
      const { productId } = action.payload;
      const productIds = [...state.validProductIds, productId];
      const validProductIds = [...new Set(productIds)];
      return {
        ...state,
        validProductIds,
      };
    }
    case VERIFY_CLIPBOARD_PRODUCT_CODES.COMPLETE: {
      const invalidProductCodes = action.payload.invalidProductCodes;
      const currentAction = action.payload.currentAction;
      const productIdCodes = action.payload.productIdCodes ?? [];
      return {
        ...state,
        invalidProductCodes,
        isValidatingProductCodes: false,
        currentAction,
        productIdCodes,
      };
    }
    case VERIFY_CLIPBOARD_PRODUCT_CODES.FAILURE: {
      return {
        ...state,
        isValidatingProductCodes: false,
      };
    }
    case RESET_CLIPBOARD: {
      return initialState;
    }
    default:
      return state;
  }
};
